module.exports = __webpack_public_path__ + "img/magento-version-switching_medium.2673d437.jpg";